import React from "react";
import Typography from "@material-ui/core/Typography";

const DateDisplay = (props: any) => {
  let { Label, DateNullText, DateValue } = props;

  const formatDate = (dateVal: string) => {
    dateVal=dateVal.replace("T", " ");
    return dateVal;
  };


  if (!DateValue) {
    return (
        <React.Fragment>
            <Typography variant="body2" component="span" gutterBottom="100">
          {DateNullText}
        </Typography>
      </React.Fragment>
    );
  }


  return (
    <React.Fragment>
      <Typography variant="body2" component="div" gutterBottom>
      <strong>{`${Label}: `}</strong> 
        <Typography variant="body2" component="span" gutterBottom="100">
          {formatDate(DateValue)}
        </Typography>
      </Typography>
    </React.Fragment>
  );
};

export default DateDisplay;
